import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {  Link } from "react-router-dom";
import { loginUserAPI } from "../services/authService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "./styles.css";

function Signin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [emailValidationErrors, setEmailValidationErrors] = useState("");
  const [passwordValidationErrors, setPasswordValidationErrors] = useState("");

  useEffect(() => {
    let isAuth = JSON.parse(localStorage.getItem("access_token"));
    if (isAuth && isAuth !== null) {
      navigate("/clients");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setShowLoading(true);
      setErrorMessage("");
      setPasswordValidationErrors("");
      setEmailValidationErrors("");

      const res = await loginUserAPI(email, password);
      setShowLoading(false);

      let responseData = await res.json();

      if (res.status === 200 || res.status === 201) {
        localStorage.setItem(
          "access_token",
          JSON.stringify(responseData.access_token)
        );
         localStorage.setItem(
          "refresh_token",
          JSON.stringify(responseData.refresh_token)
        );
         localStorage.setItem(
          "user_info",
          JSON.stringify(responseData.data)
        );
        navigate("/clients");
      } else if (res.status === 401) {
        setErrorMessage(responseData.message);
      } else if (res.status === 422) {
        let emailError = responseData.errors.find(
          (error) => error.property === "email"
        );
        if (emailError) {
          let allErrors = emailError.constraints;
          let contaivalues = Object.values(allErrors);
          setEmailValidationErrors(contaivalues[contaivalues.length - 1]);
        } else {
          setEmailValidationErrors("");
        }

        let passwordError = responseData.errors.find(
          (error) => error.property === "password"
        );
        if (passwordError) {
          let allErrors = passwordError.constraints;
          let contaivalues = Object.values(allErrors);
          setPasswordValidationErrors(contaivalues[contaivalues.length - 1]);
        } else {
          setPasswordValidationErrors("");
        }
      }
    } catch (err) {
      console.log(err);
      setShowLoading(false);
    }
  };

  const validateForm = () => {
    return !email || !password || showLoading;
  };

  return (
    <>

          <form onSubmit={handleSubmit}>
            <h2>Login</h2>

        
            <div className="inputbox relative border-b-2 border-white field-input bg-transparent mb-4">
              <input
                type="text"
                placeholder="Email ID"
                className="input w-full max-w-sm bg-transparent focus:outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <p className="text-[#ff3333] text-sm mt-1">
                {emailValidationErrors}
              </p>
            </div>

          
            <div className="inputbox relative border-b-2 border-white bg-transparent mb-4">
              <div className="relative flex items-center">
                <input
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  required
                  placeholder="Password"
                  className="input w-full max-w-sm bg-transparent focus:outline-none pr-10"
                />

      
                <span
                  className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-white hover:text-gray-300"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </span>
              </div>

              <p className="text-[#ff3333] text-sm mt-1">
                {passwordValidationErrors}
              </p>
            </div>

       
            <p className="text-[#ff3333] text-sm mb-3">{errorMessage}</p>

         
            <button
              type="submit"
              disabled={validateForm()}
              className="w-full rounded-full py-2 font-semibold text-white duration-300 button-background"
            >
              {showLoading ? "Signing in..." : "Sign in"}
            </button>

       <div className="w-full flex justify-end mt-2 mb-2">
                <Link
                  to={`/forgot-password`}
                  className="text-sm text-white hover:underline"
                >
                  Forgot Password?
                </Link>
              </div>
          </form>
    </>
  );
}

export default Signin;
